import React, { Component } from 'react';
import {
	IAssuranceProps,
	IAssuranceState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import ErrorMessage from '../App/styledComponents/ErrorMessage';
import SuccessMessage from '../App/styledComponents/SuccessMessage';
import ButtonRaised from '@kurtosys/ksys-app-components/dist/components/base/ButtonRaised';
import { ImagePicker } from '@kurtosys/ksys-app-components/dist/components/base/ImagePicker/ImagePicker';
import LabelledInput from '@kurtosys/ksys-app-components/dist/components/base/LabelledInput';
import Label from '@kurtosys/ksys-app-components/dist/components/base/Label';
import InfoMessage from '../App/styledComponents/InfoMessage';
import Translate from '@kurtosys/ksys-app-components/dist/components/base/Translate';
import { AssuranceStore } from './stores/AssuranceStore';
import { ActionTiles } from '../App/models/ActionTiles';

@inject('assuranceStore', 'messageStore', 'appStore')
@observer
export class Assurance extends Component<IAssuranceProps, IAssuranceState> {
	static configurationKey: 'assurance' = 'assurance';
	static styleKey: 'assurance' = 'assurance';

	constructor(props: IAssuranceProps) {
		super(props);
	}
	render() {
		const { className, assuranceStore, messageStore, appStore } = this.props;
		if (!assuranceStore || !messageStore || !appStore) {
			return null;
		}

		if (!appStore.isActionEnabled(ActionTiles.ASSURANCE_SETUP)) {
			return null;
		}

		const { assuranceSetupCardProps } = appStore;

		const { errorTexts, infoTexts } = messageStore;
		const { componentKey } = AssuranceStore;
		const {
			imagePickerProps,
			messageRemainingCharactersText,
			saveAssuranceButtonText,
			updateAssurances,
			messageLabelledInputProps,
			translateProps,
			labelProps,
			isValid,
		} = assuranceStore;

		return (
			<Wrapper className={ className } { ...assuranceSetupCardProps }>
				<LabelledInput
					data-qa-ref="assuranceMessageField"
					{ ...messageLabelledInputProps }
				/>
				<InfoMessage data-qa-ref="assuranceMessageRemainingCharacters">
					<Translate placeholders={ translateProps }>
						{
							messageRemainingCharactersText
						}
					</Translate>
				</InfoMessage>
				<Label { ...labelProps }
				/>
				<ImagePicker { ...imagePickerProps } />
				<ErrorMessage data-qa-ref="assuranceError" >
					{ errorTexts.get(componentKey) }
				</ErrorMessage>
				<SuccessMessage data-qa-ref="assuranceInfo">
					{ infoTexts.get(componentKey) }
				</SuccessMessage>
				<ButtonRaised
					data-qa-ref="assuranceSaveButton"
					onClick={ updateAssurances }
					disabled={ !isValid }
				>
					{ saveAssuranceButtonText }
				</ButtonRaised>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Assurance, 'assurance');

